import ThisModule from "./PublicOnlyRoute";

export default ThisModule;
